import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getDomain = async (domainId) => {
    const response = await RequestManager.get({
        url: "/domain/v1/" + domainId
    });

    return response;
};

const getAllProductsByDomain = async (domainId) => {
    const response = await RequestManager.get({
        url: `/domain/product/v1/${domainId}`
    });
    return response;
};

const updateDomain = async (domainId, body) => {
    const response = await RequestManager.put({
        url: "/domain/v1/" + domainId,
        body
    });

    return response;
};

const getAllDomains = async ({
    size,
    firstCursor,
    lastCursor,
    prev,
    getLatest,
    paginated = false,
    targetId,
    showDisabled = true,
    populate,
    filterName,
    filterEnabled,
    filterProducts,
    filterAIProviders
} = {}) => {
    const correctSize = paginated ? size : -1;
    const urlParams = Utils.getUrlParams({
        size: correctSize,
        prev,
        firstCursor,
        lastCursor,
        getLatest,
        extraQuery: {
            targetId,
            populate,
            showDisabled,
            filterName,
            filterEnabled,
            filterProducts,
            filterAIProviders
        }
    });
    const response = await RequestManager.get({
        url: `/domain/v1${urlParams}`
    });

    return {
        ...response,
        ...response.data
    };
};

const getPaginatedDomains = async ({
    size,
    firstCursor,
    lastCursor,
    prev,
    getLatest,
    targetId,
    showDisabled,
    populate,
    filterName,
    filterEnabled,
    filterProducts,
    filterAIProviders
}) => {
    return getAllDomains({
        size,
        firstCursor,
        lastCursor,
        prev,
        getLatest,
        paginated: true,
        targetId,
        showDisabled,
        populate,
        filterName,
        filterEnabled,
        filterProducts,
        filterAIProviders
    });
};

const createDomain = async (body) => {
    const response = await RequestManager.post({
        url: "/domain/v1",
        body
    });
    return response;
};

const deleteDomain = async (id) => {
    const response = await RequestManager.del({
        url: "/domain/v1/" + id
    });
    return response;
};

const Domain = {
    getDomain,
    getAllProductsByDomain,
    updateDomain,
    getAllDomains,
    getPaginatedDomains,
    createDomain,
    deleteDomain
};

export default Domain;
